import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { VDataTable,VCard,VTextField, VDataTableVirtual, VFooter ,VSwitch} from 'vuetify/components'
// Console look for the restyled pages; after vuetify/styles so its table overrides win.
import './assets/ff-console.css'
import './assets/orderhist-classic.css'
import i18n from './i18n'
// import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
    VDataTable,
    VCard,
    VTextField,
    VDataTableVirtual,
    VFooter,
    VSwitch
  })


// axios.defaults.baseURL = 'https://api.fitfood.io.vn'
// axios.defaults.baseURL = 'https://api.ann.io.vn'
// The deploy workflows sed the literal 127.0.0.1:8000 URL below into the real API host,
// so keep it verbatim; a local port change goes in fitfoodcs_vue/.env.local instead
// (VUE_APP_API_URL=..., git-ignored, read when `npm run serve` starts).
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://api.ann.io.vn'
// axios.defaults.baseURL = 'http://192.168.3.29:8000/'
// axios.defaults.baseURL = 'http://209.97.168.205:8000/'

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // console.log('interceptor error')
  // console.log(error)

  try  {
    if (error.response.status === 401) {
      store.dispatch('LogOut')
      router.push('/login')
    }
  } catch {

  }
  return Promise.reject(error)
})

createApp(App).use(store).use(router, axios).use(vuetify).use(i18n).mount('#app')
